export default "__VITE_ASSET__DotXoq5o__"